<template>
  <router-view v-if="$route.meta.layout === 'plain'" />
  <DeluxeLayout v-else>
    <router-view />
  </DeluxeLayout>
</template>


<script>
import DeluxeLayout from '@/layouts/DeluxeLayout.vue'
import {CheckSession} from '@/actions/userActions.js'
import { useCookies } from "vue3-cookies"
import { useRoute } from 'vue-router'
import 'dotenv/config'

export default {
  name: 'App',
  components: {
    DeluxeLayout
  },
  setup(){
    const { cookies } = useCookies()
    const route = useRoute()
    if(cookies.get('_auzer') && route.name !== 'SignOut'){
      CheckSession().then((res)=>{
        if(!res){
          cookies.set('_redirreq', window.location.pathname ,'15min','/','',true,'Strict')
          cookies.remove('_auzer')
          window.location.href = process.env.VUE_APP_REST_MAIN_API + "/api/auth/sso?origin="+window.location.origin
        }
      })
    }
  }
}
</script>
